module.exports = __webpack_public_path__ + "static/media/normal-type.b3772a3c.gif";